const UserId = "userId";
const TokenKey = "isLogged";
const AuthenResponse = "authenResponse";
const UserInfo = "userInfo";
const UserAgentMobile = "userAgentMobile";
const TwitterToken ="twitterToken"

export function getUserId() {
  return localStorage.getItem(UserId);
}

export function setUserId(id) {
  return localStorage.setItem(UserId, id);
}

export function removeUserId() {
  return localStorage.removeItem(UserId);
}

export function getLogged() {
  return localStorage.getItem(TokenKey);
}

export function setLogged(isLogged) {
  return localStorage.setItem(TokenKey, isLogged);
}

export function removeLogged() {
  return localStorage.removeItem(TokenKey);
}

export function getAuthenResponse() {
  return localStorage.getItem(AuthenResponse) ? JSON.parse(localStorage.getItem(AuthenResponse)) : null;
}

export function setAuthenResponse(response) {
  return localStorage.setItem(AuthenResponse, JSON.stringify(response));
}

export function removeAuthenResponse() {
  return localStorage.removeItem(AuthenResponse);
}

export function getUserInfo() {
  return localStorage.getItem(UserInfo) ? JSON.parse(localStorage.getItem(UserInfo)) : null;
}

export function setUserInfo(userInfo) {
  return localStorage.setItem(UserInfo, JSON.stringify(userInfo));
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfo);
}

export function getUserAgentMobile() {
  return localStorage.getItem(UserAgentMobile);
}

export function setUserAgentMobile(userAgentMobile) {
  return localStorage.setItem(UserAgentMobile, userAgentMobile);
}

export function removeUserAgentMobile() {
  return localStorage.removeItem(UserAgentMobile);
}

export function getTwitterToken() {
  return localStorage.getItem(TwitterToken) ? JSON.parse(localStorage.getItem(TwitterToken)) : null;
}

export function setTwitterToken(twitterToken) {
  return localStorage.setItem(TwitterToken, JSON.stringify(twitterToken));
}

export function removeTwitterToken() {
  return localStorage.removeItem(TwitterToken);
}

export function removeAllAuthCookie() {
  if (getUserId()) {
    removeUserId();
  }
  if (getLogged()) {
    removeLogged();
  }
  if (getAuthenResponse()) {
    removeAuthenResponse();
  }
  if (getUserInfo()) {
    removeUserInfo();
  }
  if (getUserAgentMobile()) {
    removeUserAgentMobile();
  }
  if (getTwitterToken()) {
    removeTwitterToken();
  }
}